import React, { FC } from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import EnvelopeLightBigIcon from '../../../../assets/images/EnvelopeLightBig.png';
import EnvelopeDarkBigIcon from '../../../../assets/images/EnvelopeBlackBig.png';
import EnvelopeLightSmallIcon from '../../../../assets/images/EnvelopeLightSmall.png';
import EnvelopeDarkSmallIcon from '../../../../assets/images/EnvelopeDarkSmall.png';

interface EnvelopeProps {
  isSmall?: boolean;
}

const defaultProps = {
  isSmall: false,
};

export const Envelope: FC<EnvelopeProps> = ({ isSmall }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'dark': {
        return isSmall ? EnvelopeDarkBigIcon : EnvelopeDarkSmallIcon;
      }
      default: {
        return isSmall ? EnvelopeLightBigIcon : EnvelopeLightSmallIcon;
      }
    }
  };

  return <img className="envelope-icon" src={getIcon(theme)} alt="BRIZ.TV logo" />;
};

Envelope.defaultProps = defaultProps;
